import React from 'react';

import { ShowHide as ShowHideShared } from '@bcp-channels-sharedcomponents-reactjs/core';
import { LoggerHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { Modal, ModalProps } from '@bcp-nextgen-dx-component-factory/design-system';

// to fix not exists children prop in react-18
const ShowHide = ShowHideShared as any;

interface ModalLocalProps extends Omit<ModalProps, 'visible'> {
	/** Set Modal Name */
	name: string;
	/** Set Event to be handle when modal close */
	onClose?: () => void;
	/** Set Event to be handle when modal opens */
	onOpen?: () => void;
}

export const ModalLocal: React.FC<ModalLocalProps> = (props) => {
	LoggerHelper.log('Module Modal Config >> Render', props);
	const { name } = props;

	return (
		<ShowHide name={name}>
			<Modal
				{...props}
				containerCustomStyle={{
					// width: '100%',
					// height: '100vh',
					bottom: '-15rem',
					left: '-19rem',
					overflow: 'hidden',
					position: 'fixed',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					zIndex: 120,
				}}
				visible
			/>
		</ShowHide>
	);
};
